export default __webpack_public_path__ + "static/media/manageResumes.d6ac0769.png";